




import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import Maamaasbanner from "./Maamaasbanner.jsx";

const Auth = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [showForgetPassword, setShowForgetPassword] = useState(false);
    const [isForgot, setIsForgot] = useState(false);
    const [loginObj, setLoginObj] = useState({
        userName: "",
        password: "",
    });
    const [hidePassword, setHidePassword] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [showPasswordFields, setShowPasswordFields] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [showLogin, setShowLogin] = useState(false);
    const [isSignup, setIsSignup] = useState(false);
    const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
    const [emailCheckMessage, setEmailCheckMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showDownloadPopup, setShowDownloadPopup] = useState(false);
    const [loginStepStarted, setLoginStepStarted] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    // New state for navbar background
    const [isNavbarTransparent, setIsNavbarTransparent] = useState(true);

    // Handle scroll effect
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsNavbarTransparent(false);
            } else {
                setIsNavbarTransparent(true);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);



    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 600); // adjust breakpoint
        handleResize(); // initial check
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleResetPassword = async () => {
        if (!email) {
            alert("Please enter your email");
            return;
        }

        try {
            const response = await fetch(
                `https://backend.maamaas.com/subscription/api/auth/vendor/reset-password?identifier=${encodeURIComponent(email)}`,
                {
                    method: "PUT",
                    headers: {
                        Accept: "*/*",
                    },
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Password reset failed");
            }

            alert("Password reset link has been sent!");
        } catch (err) {
            console.error("❌ Error resetting password:", err);
            alert("Reset Password send to mailId!");
        }
    };

    const handleEmailCheck = async (e) => {
        e.preventDefault();
        const email = loginObj.emailId?.trim();

        if (!email) {
            alert("Please enter a valid email.");
            return;
        }

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/subscription/vendor-enquiries/get-email`,
                {
                    params: { emailId: email },
                }
            );

            const vendorData = response.data;

            if (vendorData?.vendorId) {
                localStorage.setItem("vendorId", vendorData.vendorId);
                alert("✅ Email verified and vendor ID stored.");
                navigate("/Newmainlandingpage");
            } else {
                console.warn("⚠️ No vendorId found in API response.");
                alert("Vendor not found. Please try again.");
            }
        } catch (error) {
            console.error("❌ Error during email check:", error.response?.data || error.message);
            alert("Failed to check email. Please try again.");
        }
    };

    const handleChange = (e) => {
        setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        const requestBody = {
            userName: loginObj.userName,
            emailId: loginObj.emailId,
            password: loginObj.password,
            mobileNumber: loginObj.mobileNumber,
            role: "ADMIN",
        };

        alert(`Role being sent: ${requestBody.role}`);

        const apiUrl =
            "http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/user/registration";

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            if (response.ok) {
                alert("Signup successful!");
                navigate("/home");
                setIsSignup(false);
                setIsForgot(false);
            } else {
                const result = await response.json();
                setError(result.message || "Signup failed");
            }
        } catch (error) {
            setError("Something went wrong. Please try again.");
        }

        setIsLoading(false);
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setLoginObj((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            const url = `https://backend.maamaas.com/subscription/api/auth/login/vendor?identifier=${encodeURIComponent(
                loginObj.userName
            )}&password=${encodeURIComponent(loginObj.password)}`;

            const response = await fetch(url, {
                method: "POST",
                headers: { Accept: "*/*" },
                body: "",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Login failed");
            }

            // Clear previous login data
            localStorage.clear();

            // Store fields
            localStorage.setItem("authToken", data.token || "");
            localStorage.setItem("refreshToken", data.refreshToken || "");
            localStorage.setItem("userId", data.userId?.toString() || "");
            localStorage.setItem("vendorId", data.vendorId?.toString() || "");
            localStorage.setItem("role", data.role || "");
            localStorage.setItem("employeRole", data.employeRole || "");
            localStorage.setItem("employeeId", data.employeeId?.toString() || "");

            // Store planTypes as JSON string
            if (Array.isArray(data.planTypes)) {
                localStorage.setItem("planTypes", JSON.stringify(data.planTypes));
            } else {
                localStorage.setItem("planTypes", JSON.stringify([]));
            }

            // Store businessVerticals as JSON
            if (Array.isArray(data.businessVerticals)) {
                localStorage.setItem("businessVerticals", JSON.stringify(data.businessVerticals));
            } else {
                localStorage.setItem("businessVerticals", JSON.stringify([]));
            }

            // Optional: store full response
            localStorage.setItem("loginResponse", JSON.stringify(data));

            // Navigate after login
            navigate("/fooddashboard");

        } catch (err) {
            console.error("❌ Login error:", err);
            setError("Login failed: " + err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const response = await fetch(
                "http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/forgot/password",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "*/*",
                    },
                    body: JSON.stringify({ identifier: email }),
                }
            );

            const text = await response.text();
            if (!response.ok) {
                throw new Error(text || "Something went wrong.");
            }

            setMessage("Password reset email sent successfully!");
            setShowPasswordFields(true);
            setIsEmailSubmitted(true);
        } catch (error) {
            setMessage(error.message || "Something went wrong. Try again later.");
        } finally {
            setLoading(false);
        }
    };

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    const styles = {
        appContainer: {
            display: 'flex',
            flexDirection: 'column',
            // minHeight: '80vh',
        },
        navBar: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px 15px',
            background: isNavbarTransparent
                ? 'transparent'
                : 'linear-gradient(135deg, #b04fe4ff, #a939b3ff, #aa48cbff)',
            zIndex: 1000,
            boxShadow: isNavbarTransparent
                ? 'none'
                : '0 2px 10px rgba(0,0,0,0.1)',
            transition: 'all 0.3s ease-in-out',
            backdropFilter: isNavbarTransparent ? 'none' : 'blur(5px)',
            WebkitBackdropFilter: isNavbarTransparent ? 'none' : 'blur(5px)',
        },
        logo: {
            fontSize: '30px',
            fontWeight: 'bold',
            fontFamily: 'sans-serif',
            color: isNavbarTransparent ? 'white' : 'white',
            margin: 0,
            textShadow: isNavbarTransparent ? '2px 2px 4px rgba(0,0,0,0.5)' : 'none',
            transition: 'all 0.3s ease-in-out',
        },
        signInButton: {
            // backgroundColor: 'white',
            color: 'white',
            fontSize: '20px',
            // fontFamily: 'Lato, sans-serif',
            fontWeight: 'bold',
            borderRadius: '16px',
            width: '90px',
            height: '40px',
            border: 'none',
            cursor: 'pointer',
        },

        topText: {
            textAlign: 'center',
            marginBottom: '40px',
            marginTop: '20px',
        },
        topH2: {
            fontSize: '50px',
            marginBottom: '10px',
            fontWeight: 'bold',
            color: 'white',
        },
        topP: {
            fontSize: '50px',
            fontWeight: 'bold',
            color: 'white',
        },
        downloadBtn: {
            backgroundColor: '#ffe124',
            color: 'rgb(42 9 71)',
            padding: '12px 25px',
            fontSize: '20px',
            border: 'ipx solid #ccc',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: '0.3s ease',
            fontWeight: 'bold',
            marginTop: '20px',
        },
        mainContent: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '20px',
            marginBottom: '40px',
            flexWrap: 'wrap',
        },
        textSection: {
            flex: 1,
            minWidth: '280px',
        },
        textH3: {
            fontSize: '30px',
            marginBottom: '30px',
            color: 'white',
            fontWeight: 'bold',
            textAlign: 'left',
        },
        textP: {
            fontSize: '20px',
            color: 'white',
            textAlign: 'left',
            fontWeight: 'bold',
            fontFamily: 'revert',
        },
        imageSection: {
            flex: 1,
            textAlign: 'center',
            marginTop: '40px',
        },
        image: {
            width: '100%',
            maxWidth: '600px',
            height: 'auto',
            borderRadius: '10px',
        },
        // popupOverlay: {
        //     position: 'fixed',
        //     top: 0,
        //     left: 0,
        //     width: '100%',
        //     height: '100%',
        //     background: 'rgba(0, 0, 0, 0.5)',
        //     display: 'flex',
        //     justifyContent: 'center',
        //     alignItems: 'center',
        //     zIndex: 1000,
        // },
        popupInner: {
            background: 'white',
            padding: '30px',
            borderRadius: '10px',
            textAlign: 'center',
            position: 'relative',
            maxWidth: '400px',
            animation: 'slideUp 0.4s ease',
            zIndex: 1001,
        },
        closeBtn: {
            position: 'absolute',
            top: '10px',
            right: '15px',
            fontSize: '20px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
        },
        scannerImg: {
            width: '200px',
            height: 'auto',
            marginBottom: '15px',
        },
        loginPopup: {
            position: 'fixed',
            top: 75,
            right: showLogin ? '0' : '-100%',
            width: '100%',
            maxWidth: '400px',
            backgroundColor: 'white',
            borderRadius: '20px',
            padding: '40px 30px',
            boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.1)',
            transition: 'right 0.5s ease-in-out',
            zIndex: 999,
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            overflowY: 'auto',
        },
        // Responsive styles
        '@media (max-width: 1024px)': {
            topH2: {
                fontSize: '42px',
            },
            topP: {
                fontSize: '42px',
            },
            textH3: {
                fontSize: '26px',
            },
        },
        '@media (max-width: 768px)': {
            navBar: {
                padding: '10px 15px',
            },
            logo: {
                fontSize: '24px',
            },
            signInButton: {
                fontSize: '16px',
                width: '80px',
                height: '35px',
            },
            topH2: {
                fontSize: '32px',
            },
            topP: {
                fontSize: '32px',
            },
            textH3: {
                fontSize: '22px',
                marginLeft: '0',
                textAlign: 'center',
            },
            textP: {
                fontSize: '16px',
                textAlign: 'center',
            },
            mainContent: {
                flexDirection: 'column',
            },
            image: {
                height: 'auto',
            },
            loginPopup: {
                maxWidth: '90%',
                height: '70vh',
            },
        },
        '@media (max-width: 480px)': {
            topH2: {
                fontSize: '28px',
            },
            topP: {
                fontSize: '28px',
            },
            downloadBtn: {
                padding: '10px 20px',
                fontSize: '18px',
            },
            textH3: {
                fontSize: '20px',
            },
        },
    };

    return (
        <div style={styles.appContainer}>
            {/* Fixed Navigation Bar with transparent effect */}
            <div style={styles.navBar}>
                <div style={styles.logo}>MAAMAA'S</div>
                <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    {/* Download App Button */}
                    <button
                        style={{
                            border: "1px solid white",
                            backgroundColor: "transparent",
                            color: "white",
                            fontSize: isMobile ? "14px" : "18px", // smaller font on mobile
                            fontWeight: "bold",
                            padding: isMobile ? "4px 10px" : "8px 16px", // smaller padding
                            cursor: "pointer",
                            borderRadius: "8px",
                            transition: "0.3s ease",
                            marginRight: "8px", // space between buttons
                            display:window.innerWidth<769 ? "none" : "block",
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.color = "white";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = "transparent";
                            e.target.style.color = "white";
                        }}
                        onClick={() => setShowDownloadPopup(true)}
                    >
                        Download App
                    </button>

                    {/* Login Button */}
                    <button
                        style={{
                            background: "transparent",
                            border: "1px solid white",
                            color: "white",
                            fontSize: isMobile ? "14px" : "18px",
                            fontWeight: "bold",
                            padding: isMobile ? "4px 10px" : "6px 12px",
                            cursor: "pointer",
                            position: "relative",
                            transition: "0.3s ease",
                            textShadow: '1px 1px 3px rgba(0,0,0,0.5)',
                            borderRadius: "8px",
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.color = "white";
                            const line = e.target.querySelector("span");
                            if (line) line.style.width = "100%";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.color = "white";
                            const line = e.target.querySelector("span");
                            if (line) line.style.width = "40%";
                        }}
                        onClick={() => setShowLogin(true)}
                    >
                        Login
                        <span
                            style={{
                                display: "block",
                                height: "2px",
                                background: "white",
                                width: "40%",
                                marginTop: "4px",
                                transition: "0.3s ease",
                                boxShadow: '1px 1px 3px rgba(0,0,0,0.5)',
                            }}
                        ></span>
                    </button>

                </div>
            </div>

            {/* Main Content */}
            <div style={styles.contentContainer}>
                <Maamaasbanner />

                {/* Your existing content goes here */}
                {/* ... rest of your content ... */}
            </div>

            {/* Login Popup */}
            <div style={{
                ...styles.loginPopup,
                right: showLogin ? '0' : '-100%',
            }}>
                <button
                    style={{
                        position: 'absolute',
                        top: '15px',
                        right: '20px',
                        fontSize: '28px',
                        background: 'none',
                        border: 'none',
                        color: '#333',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        setShowLogin(false);
                        setIsForgot(false);
                        setIsSignup(false);
                    }}
                >
                    &times;
                </button>

                <p style={{
                    marginBottom: 0,
                    fontFamily: 'revert',
                    fontSize: '22px',
                    color: 'black',
                    fontWeight: 'bold',
                }}>
                    WELCOME TO MAAMAA'S
                </p>

                {/* Login Form */}
                {!loginStepStarted && !isForgot && (
                    <>
                        <form onSubmit={handleEmailCheck} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <input
                                type="email"
                                placeholder="Enter your Email to Start"
                                name="emailId"
                                value={loginObj.emailId}
                                onChange={handleChange}
                                required
                                style={{
                                    padding: '10px',
                                    fontSize: '16px',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                }}
                            />
                            <button
                                type="submit"
                                style={{
                                    backgroundColor: 'rgb(42 9 71)',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    padding: '12px',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                }}
                            >
                                Check & Save
                            </button>
                        </form>

                        {emailCheckMessage && <p style={{ marginTop: '10px', color: 'green' }}>{emailCheckMessage}</p>}
                        <p style={{ marginTop: '10px', fontSize: '14px' }}>
                            Already signed up?{' '}
                            <span
                                onClick={() => {
                                    setIsSignup(false);
                                    setLoginStepStarted(true);
                                }}
                                style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                            >
                                Login here
                            </span>
                        </p>
                    </>
                )}

                {/* Login Form */}
                {!isForgot && loginStepStarted && (
                    <>
                        <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <input
                                type="text"
                                placeholder="User ID"
                                name="userName"
                                value={loginObj.userName}
                                onChange={handleChanges}
                                style={{
                                    padding: '10px',
                                    fontSize: '16px',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                }}
                            />


                            <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    name="password"
                                    value={loginObj.password}
                                    onChange={handleChanges}
                                    style={{
                                        padding: "10px",
                                        paddingRight: "40px",
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        width: "100%",
                                        boxSizing: "border-box"
                                    }}
                                />
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        right: "10px",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#888"
                                    }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <span
                                    onClick={() => setIsForgot(true)}
                                    style={{
                                        color: '#007bff',
                                        fontSize: '14px',
                                        textDecoration: 'none',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Forgot Password?
                                </span>
                            </div>
                            {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
                            <button
                                type="submit"
                                style={{
                                    backgroundColor: 'red',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    padding: '12px',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                }}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Logging in...' : 'LOGIN'}
                            </button>
                        </form>
                    </>
                )}

                {/* Forgot Password Form */}
                {isForgot && !isEmailSubmitted && (
                    <form onSubmit={handleResetPassword}>
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={handleEmailChange}
                            required
                            style={{
                                padding: '10px',
                                fontSize: '16px',
                                border: '1px solid #ccc',
                                borderRadius: '6px',
                                marginBottom: '10px',
                                width: '100%',
                            }}
                        />
                        <button
                            type="submit"
                            style={{
                                backgroundColor: 'red',
                                color: 'white',
                                fontWeight: 'bold',
                                padding: '12px',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                width: '100%',
                            }}
                            disabled={loading}
                        >
                            {loading ? 'Sending...' : 'Submit'}
                        </button>
                        {message && (
                            <div style={{ marginTop: '10px', color: message.includes('successfully') ? 'green' : 'red' }}>
                                {message}
                            </div>
                        )}
                    </form>
                )}

                {/* Switch Between Login & Signup */}
                {!isForgot && (
                    <div style={{ textAlign: 'center' }}>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                justifyContent: 'center',
                            }}
                        >

                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Auth;